(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDialogController', SSAnioDialogController);

    SSAnioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAnio', 'SSPeriodo'];

    function SSAnioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSAnio, SSPeriodo) {
        var vm = this;

        vm.sSAnio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperiodos = SSPeriodo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSAnio.id !== null) {
                SSAnio.update(vm.sSAnio, onSaveSuccess, onSaveError);
            } else {
                SSAnio.save(vm.sSAnio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAnioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
